import { defaultTheme } from "matsuri-ui";
export const theme = {
    ...defaultTheme,
    /**
     * FIXME: 本当は8にしたいが以下の問題があるため、7にしておく
     * https://github.com/matsuri-tech/matsuri-ui/issues/1600
     * https://github.com/matsuri-tech/matsuri-ui/issues/1601
     */
    spacing: 7,
    typography: {
        ...defaultTheme.typography,
        body: {
            ...defaultTheme.typography.body,
            fontSize: 16,
        },
    },
    palette: {
        ...defaultTheme.palette,
        intentions: {
            ...defaultTheme.palette.intentions,
            primary: {
                light: "#6E9EEB",
                main: "#3c78d8",
                dark: "#1C4586",
                contrastText: "#FFF",
            },
        },
    },
};
